/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-06 15:14:01
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const CHECK_LIVE_THEME_SUPPORTED_REQUEST = 'CHECK_LIVE_THEME_SUPPORTED_REQUEST';
type CHECK_LIVE_THEME_SUPPORTED_REQUEST_TYPE = 'CHECK_LIVE_THEME_SUPPORTED_REQUEST';

export const CHECK_LIVE_THEME_SUPPORTED_SUCCESS = 'CHECK_LIVE_THEME_SUPPORTED_SUCCESS';
type CHECK_LIVE_THEME_SUPPORTED_SUCCESS_TYPE = 'CHECK_LIVE_THEME_SUPPORTED_SUCCESS';

export const CHECK_LIVE_THEME_SUPPORTED_FAILURE = 'CHECK_LIVE_THEME_SUPPORTED_FAILURE';
type CHECK_LIVE_THEME_SUPPORTED_FAILURE_TYPE = 'CHECK_LIVE_THEME_SUPPORTED_FAILURE';

// Check live theme supported
type LiveThemeSupportedSuccess = {};
type LiveThemeSupportedFailure = {
  error: any
};
type CheckLiveThemeSupportedRequestAction = Action<CHECK_LIVE_THEME_SUPPORTED_REQUEST_TYPE, null>;

type CheckLiveThemeSupportedSuccessAction = Action<
  CHECK_LIVE_THEME_SUPPORTED_SUCCESS_TYPE,
  LiveThemeSupportedSuccess
>;

type CheckLiveThemeSupportedFailureAction = Action<
  CHECK_LIVE_THEME_SUPPORTED_FAILURE_TYPE,
  LiveThemeSupportedFailure
>;

export type FeaturesAction =
  | CheckLiveThemeSupportedRequestAction
  | CheckLiveThemeSupportedSuccessAction
  | CheckLiveThemeSupportedFailureAction;

export type FeaturesState = {
  isLiveThemeSupported: boolean,
  loading: boolean,
  success: boolean,
  error: any
};
